import Checkmark from '../../src/legacy/Checkmark.tsx';
export default Checkmark;
